<template>
	<div class="empty-box">
		<img class="title-img" src="../assets/empty-title.png"/>
		<img class="bg-img"  v-if="xgUserInfo.providerCode == 'nongfu'" src="../assets/empty-bg.png"/>
		<img class="bg-img"  v-if="xgUserInfo.providerCode != 'nongfu'" src="../assets/empty2.png"/>
		<div class="opt-div">
			<Option color="#ffffff" bgColor="#98c1f1"></Option>
		</div>
		
		<div class="art-div" v-if="xgUserInfo.providerCode == 'nongfu'">
			<div id="qrcode" ref="qrcode"></div>
		</div>
		
		<div class="btn-div flex-between" v-if="xgUserInfo.providerCode == 'nongfu'">
			<div class="btn-left t-c">
				<div class="white w-550 f-s-13">今日积分已兑完</div>
				<div class="white w-550 f-s-11">明日12点前来领</div>
			</div>
			<div class="btn-right t-c">
				<div class="red w-550 f-s-13">保存图片微信</div>
				<div class="red w-550 f-s-13">扫码明天再兑</div>
			</div>
		</div>
		
		<div class="service-div white f-s-12 t-c" v-if="xgUserInfo.providerCode == 'nongfu'">客服热线：4000808910（9:00至21:00）</div>
	</div>
</template>

<script>
	import Option from '../components/home/Option.vue'
	import QRCode from 'qrcodejs2'
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex"
	export default {
		created(){
			this.$nextTick (function () {
			   this.qrcode();
			})
		},
		computed: mapGetters(['xgUserInfo']),
		components: {
			[Option.name]: Option,
			[QRCode.name]: QRCode
		},
		name: 'Empty',
		data() {
			return {
				
			}
		},
		methods:{
			qrcode () {
			   if(this.xgUserInfo.providerCode != 'bianfeng'){
				  return
			   }
			  let uri = "https://jf.ydong.com.cn/?areaNo="+this.xgUserInfo.region +"&openid="+this.xgUserInfo.openId
			  let qrcode = new QRCode('qrcode', {  
			      // width: ,
			      // height: 375,
			      text: uri
			  })  
			}
		}
	}
</script>

<style scoped>
	.empty-box {
		position: relative;
		width: 100%;
		height: calc(100% + 20px);
		background-color: #3c67dc;
	}
	
	.opt-div {
		width: 80px;
		height: max-content;
		position: absolute;
		top: 55px;
		right: 0;
		z-index: 2;
	}
	
	.art-div {
		background-color: #ffffff;
		width: 140px;
		height: 140px;
		padding: 10px;
		position: absolute;
		top: 365px;
		left: calc(50% - 65px);
		z-index: 1;
	}
	
	.art-div /deep/ img{
		width: 100%;
	}
	
	.title-img {
		width: 70%;
		height: auto;
		position: absolute;
		top: 30px;
		left: 15%;
		z-index: 2;
	}
	.bg-img {
		width: 100%;
		height: auto;
		position: absolute;
		top: 120px;
		left: 0;
	}
	.btn-div {
		padding: 0 52px;
		width: 100%;
		height: auto;
		position: absolute;
		top: 550px;
		left: 0;
	}
	.service-div {
		width: 100%;
		height: auto;
		position: absolute;
		top: 630px;
		left: 0;
		background-color: #3c67dc;
	}
	
	.btn-left {
		padding: 5px 0px 8px 0px;
		width: 124px;
		height: max-content;
		background-image: url(../assets/empty_l_btn.png);
		background-size: 100% 100%;
	}
	.btn-right {
		padding: 5px 0px 8px 0px;
		width: 124px;
		height: max-content;
		background-image: url(../assets/empty_r_btn.png);
		background-size: 100% 100%;
	}
	
	.art-div /deep/ canvas{
		width: 120px;
		height: 120px;
		margin: auto;
	}

	.art-div /deep/ img{
		width: 120px;
		height: 120px;
		margin: auto;
	}
</style>
